// Hora opcional da atividade ("HH:MM"), usada no calendário, no kanban e nas listas.

export interface ActivityTimeLike {
  start_time?: string | null;
  end_time?: string | null;
}

/** "09:00" ou "09:00–10:30" — vazio quando a atividade não tem hora; "até 10:30" só com fim. */
export const timeRange = (activity: ActivityTimeLike): string => {
  const start = activity.start_time ?? '';
  const end = activity.end_time ?? '';
  if (!start && !end) return '';
  if (start && end) return `${start}–${end}`;
  return start || `até ${end}`;
};
